import AbstractSegment from '../AbstractSegment';
import uaParsed from 'util/ua';



const DEVICE_DEFINE = {
  pc: 1, // desktop or tablet
  sp: 2, // phone
};

const UA_DEVICE_TYPE = uaParsed.device.type === 'mobile' ? 'sp' : 'pc';
const DEFAULT_UID    = randobet(32);
const DEFAULT_TYPE   = DEVICE_DEFINE[UA_DEVICE_TYPE];

const defaults = {
  uid : DEFAULT_UID,
  type: DEFAULT_TYPE,
}



export default class UserType extends AbstractSegment {
  name = 'device';



  /**
   * constructor
   */
  constructor(context) {
    super(context);
    this.initData();
  }

  async initData() {
    await this.context.ready();
    this.set();
  }



  /**
   * get
   */
  get(defaultValues = defaults) {
    const _data = this._get();
    let data;

    try {
      data = JSON.parse(_data);
      data = Object.assign(defaults, data);
    } catch(e) {
      data = defaults;
    }

    // デバイス種別は更新する
    data.type = DEFAULT_TYPE;
    return data;
  }



  /**
   * set
   */
  set(data = {}) {
    const current = this.get();
    const storeData = Object.assign({}, current, data);
    this._set(JSON.stringify(storeData));
  }
}



// ランダムな文字列を取得
function randobet(n, b = '') {
  let a = 'abcdefghijklmnopqrstuvwxyz'
        + 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
        + '0123456789'
        + b;

  a = a.split('');

  let s = '';

  for (let i = 0; i < n; i++) {
    s += a[Math.floor(Math.random() * a.length)];
  }

  return s;
}



// WEBPACK FOOTER //
// ./src/shared/bc-segments/segments/Device/Device.js